// @flow

// Thanks to Dan Abramov for this gem <3
// https://overreacted.io/making-setinterval-declarative-with-react-hooks/

import * as React from 'react';

function useInterval(callback: any, delay: number) {
  const savedCallback = React.useRef();

  // Remember the latest callback.
  React.useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  React.useEffect(() => {
    let id;
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      id = setInterval(tick, delay);
      return () => clearInterval(id);
    }

    return () => clearInterval(id);
  }, [delay]);
}

export default useInterval;
